
<p-table
        #dt
        sortMode="multiple"
        [columns]="headers"
        [value]="currentData"
        [paginator]="true"
        sortMode="multiple"
        [rowsPerPageOptions]="[5, 10, 25, 50]"
        [rows]="5"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{{'text.showing' | translate}} {first} {{'text.to' | translate}} {last} {{'text.of' | translate}} {totalRecords} {{'text.entries' | translate}}"
        [globalFilterFields]="['requestId','reportCategory','reportType','createdDate','createdBy','status']"
        [styleClass]="selectedCountry === 'FR' ? 'p-datatable-sm fr-table-top-border' : 'p-datatable-sm'"
        [customSort]="selectedCountry === 'FR'"
        (sortFunction)="customSortFunction($event)"
        [scrollable]="selectedCountry === 'FR'? false: true"
        scrollHeight="300px"
        [scrollHeight]="selectedCountry === 'FR' ? null : '300px'"
        responsiveLayout="scroll"
        [resizableColumns]="true"
        class="common-table bordered"
        [resizableColumns]="true"
        columnResizeMode="expand"
>
  <ng-template *ngIf="!isSidebarLayout" pTemplate="caption">
    <div class="p-d-flex search-input d-flex justify-content-end">
    <span class="p-input-icon-left p-ml-auto">
      <i class="pi pi-search"></i>
      <input
              pInputText
              type="text"
              size="25"
              (input)="dt.filterGlobal($event.target.value, 'contains')"
              placeholder="{{'text.Searchkeyword' | translate}}"
      />
    </span>
    </div>
  </ng-template>
  <ng-template pTemplate="sorticon" let-sortOrder>
    <ng-container *ngIf="selectedCountry === 'FR'; else defaultSortIcon">
      <span class="fr-custom-sort-icon">
        <i *ngIf="sortOrder === 0" class="pi pi-angle-up sort-default"></i>
        <i *ngIf="sortOrder === 0" class="pi pi-angle-down sort-default"></i>
        <i *ngIf="sortOrder === 1" class="pi pi-angle-up sort-active"></i>
        <i *ngIf="sortOrder === -1" class="pi pi-angle-down sort-active"></i>
      </span>
    </ng-container>
    <ng-template #defaultSortIcon>
      <i *ngIf="sortOrder === 0" class="pi pi-sort-alt"></i>
      <i *ngIf="sortOrder === 1" class="pi pi-sort-amount-up-alt"></i>
      <i *ngIf="sortOrder === -1" class="pi pi-sort-amount-down"></i>
    </ng-template>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th
              *ngFor="let col of headers"
              pResizableColumn
              [pSortableColumn]="col.value"
      >
        {{ col.field }}
        <p-columnFilter *ngIf="!isSidebarLayout" 
                class="ms-auto"
                type="text"
                [field]="col.value"
                display="menu"
        ></p-columnFilter>
        <p-sortIcon  [field]="col.value"></p-sortIcon>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData>
    <tr>
      <td>
        {{ rowData.requestId }}
        <i class="me-2" style='color: #9ca3a8;margin-left: 10px;' class="pi pi-info-circle"
           (click)="displayReportParamDetails(rowData.requestId)"></i>
      </td>
      <td>
        {{ rowData.reportCategory }}
      </td>
      <td>
        {{ rowData.reportType }}
      </td>
      <td>
        {{ rowData.createdDate | date:'yyyy-MM-dd HH:mm:ss' }}
      </td>
      <td>
        {{ rowData.createdBy }}
      </td>
      <td>
        {{ rowData.status }}
        <download-data style="padding-left: 5px;" *ngIf="rowData.genCheck === true" [type]="'anchor'" [fileName]="rowData.requestId"
                       [bypassCheck]=true  [reportCateg]="rowData.downloadCateg" [path] = "'Report'">
        </download-data>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="0">{{'text.noData' | translate}}</td>
    </tr>
  </ng-template>
</p-table>
<p-dialog header="{{'text.rprtparamDetails' | translate}}" class="report-information" [focusOnShow]="false" [closable]="false" [(visible)]="displayReports" [modal]="true">
  <div class="d-flex m-b-10">
    <div class="p-3 pad">
      <label [ngStyle]='{"font-weight":"bold"}'>{{'text.criteria' | translate}}:</label>
      <span>&nbsp;{{ CriteriaParam }}</span>
    </div>
    <div class="p-3 pad">
      <label [ngStyle]='{"font-weight":"bold"}'>{{'text.fromDate' | translate}}: </label>
      <span>&nbsp;{{ fromDateParam }}</span>
    </div>
    <div class="p-3 pad">
      <label [ngStyle]='{"font-weight":"bold"}'>{{'text.toDate' | translate}}: </label>
      <span>&nbsp;{{ toDateParam }}</span>
    </div>
    <div class="p-3 pad">
      <label [ngStyle]='{"font-weight":"bold"}'>{{'text.recordStatus' | translate}}: </label>
      <span>&nbsp;{{ recordStatus }}</span>
    </div>
    <div class="p-3 pad">
      <label [ngStyle]='{"font-weight":"bold"}'>{{'text.invoiceType' | translate}}: </label>
      <span>&nbsp;{{ invoiceType }}</span>
    </div>
  </div>
  <p-footer>
    <button tabindex='-1' (click)="displayReports = false;" mat-flat-button class="yellow-btn">{{'text.close' | translate}}</button>
  </p-footer>
</p-dialog>
